module.exports = __webpack_public_path__ + "img/bronze.42e86a84.svg";